import { TSize } from 'volta/utils/style-utils';

import Component from '@glimmer/component';

interface IArgs {
  tag?: string;
  text?: string;
  size: TSize;
}

export default class BvDisplayText extends Component<IArgs> {
  get sizeClassName() {
    const { size } = this.args;
    if (!size) {
      return '';
    }
    return `bv-display-text--${size.toLowerCase()}`;
  }
}
